/**
  * Generates an object suitable for insertion within an application/ld+json script describing a credit card.
  *
  * @param {object} cardInfo
  * @param {string} cardInfo.name
  * @param {string} cardInfo.cardImageURL
  * @param {number} cardInfo.purchaseInterest
  * @param {number} cardInfo.ratehubReview.rating
  * @param {string} cardInfo.ratehubReview.reviewAuthor.name
  * @param {string} [cardInfo.ratehubReview.reviewAuthor.profileURL]
  *
  * @return {object} for inserting within script of application/ld+json
  */
function getCreditCardSchema(cardInfo) {
    const { ratehubReview } = cardInfo;

    return Object.assign(
        {
            '@context': 'http://schema.org',
            '@type': 'Product',
            name: cardInfo.name,
            image: cardInfo.cardImageURL,
            description: 'credit card',
            category: {
                '@type': 'CreditCard',
                name: cardInfo.name,
                annualPercentageRate: cardInfo.purchaseInterest ?? 'n/a',
            },
        },
        ratehubReview && {
            review: {
                '@type': 'Review',
                // consider a rating of 0 as unspecified; omit from schema
                ...ratehubReview.rating > 0 && {
                    reviewRating: {
                        '@type': 'Rating',
                        ratingValue: ratehubReview.rating,
                        bestRating: 5,
                        worstRating: 0,
                    },
                },
                author: {
                    '@type': 'Person',
                    name: ratehubReview.reviewAuthor.name,
                    ...(ratehubReview.reviewAuthor.profileURL && {
                        sameAs: ratehubReview.reviewAuthor.profileURL,
                    }),
                },
            },
        },
    );
}

export default getCreditCardSchema;
